import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
// import { MsalService } from "@azure/msal-angular";
import { AzureAdModel, OAuthSettingsConfig, TenantInformation, VerFiedUserModel } from "./azure-ad.interface";

@Injectable({ providedIn: 'root' })
export class AzureInfoService {
    azureAdInfo: AzureAdModel;
    azureOAuthSettings: OAuthSettingsConfig;
    tenantInfo: TenantInformation;
    authenticated: boolean;
    constructor(
    ) { }
    

    
}